import React from 'react';
import styled from 'styled-components';

const GaugeBar = ({ value, color }) => (
    <BarWrapper>
        <Bar
            width={value}
            color={color}
        />

        <BarComplement
            width={100 - value}
        />
    </BarWrapper>
);

const BarWrapper = styled.div`
    display:flex;
    width: 100%;
`;

const Bar = styled.div`
  background: ${({ color }) => color}; 
  height: 8px;
  border-radius:4px;
  width: ${({ width }) => (width === 0 ? 1 : width)}%;
  transition: width .5s ease-out;
`;

const BarComplement = styled.div`
    background: #E9EDF2;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    height: 6px;
    margin-top:1px;
    width: ${({ width }) => width}%;
    transition: width .5s ease-out;
`;

GaugeBar.defaultProps = {
    value: 0,
};

export default GaugeBar;
